<template>
  <!-- NOTE (TEMPLATE) to show the active proposals -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-card
      v-if="$router.currentRoute.path == '/admin/demands/letterSent'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h4>
        <v-row class="btn-radius" style="margin: 10px 1px">
          <v-col>
            <p>درخواست‌های حوزه فعالیت دارای نامه تاییدیه</p>
          </v-col>
          <v-col>
            <v-btn
              class="bc-primary text-white btn-radius float-end"
              width="200"
              height="45"
              elevation="0"
              :disabled="isBusy || !items.length"
              @click="$refs.table1.$el.click()"
            >
              <span class="fs-small">
                خروجی اکسل

                <v-icon>$Excel</v-icon></span
              >
            </v-btn>
            <vue-excel-xlsx
              v-show="false"
              ref="table1"
              :data="items"
              :columns="excelFields"
              :filename="'درخواست‌های حوزه فعالیت اصلاح شده'"
              :sheetname="currentDate"
            >
              دریافت اکسل
            </vue-excel-xlsx>
          </v-col>
        </v-row>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            class="mt-1"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h4>

      <!-- NOTE (t-activeProposals) to show the active proposals list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="items"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="رکوردی برای نمایش وجود ندارد"
        empty-filtered-text="رکوردی برای نمایش وجود ندارد"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(demandStatus)="data">
          <div style="text-align: center; vertical-align: middle; width: 150px">
            {{ data.item.demandStatus }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle; width: 150px">
            <b-button
              :to="'/admin/demands/demand/' + data.item.id"
              target="_blank"
              variant="success"
              class="m-2 text-light"
              >بررسی</b-button
            >
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
  components: {},
  data: function () {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      fields: [
        { key: "index", label: "ترتیب" },
        { key: "university", label: "نام دانشگاه" },
        { key: "demandStatus", label: "نوع درخواست" },
        { key: "lastUpdated", label: "آخرین بروزرسانی", sortable: true },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "index", label: "ترتیب" },
        { field: "university", label: "نام دانشگاه" },
        { field: "demandStatus", label: "نوع درخواست" },
        { field: "lastUpdated", label: "آخرین بروزرسانی", sortable: true },
      ],
      items: [],
      filter: "",
      selectedType: "all",
      isBusy: true,
      busy: false,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
    };
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onMounted() {
      this.isBusy = true;
      // NOTE (MOUNTED) to show the proposals data
      this.$http
        .get(this.baseUrl + "/setad/admin/demands/letterSent", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.items = res.data;
          this.totalRows = this.items.length;
          this.items.forEach((item) => {
            item.demandStatus = item.isConfirmed
              ? "تایید حوزه‌‌ها"
              : item.isChange
              ? "درخواست تغییر"
              : "-";
          });
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },
  mounted() {
    if (this.$router.currentRoute.path == "/admin/demands/letterSent")
      this.onMounted();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../../assets/fonts/IRANSans(FaNum).ttf");
}
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
.reject-select {
  .vs__dropdown-menu {
    direction: rtl !important;
  }
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
